import { render } from "./EditableText.vue?vue&type=template&id=0a0393ba&scoped=true"
import script from "./EditableText.vue?vue&type=script&lang=js"
export * from "./EditableText.vue?vue&type=script&lang=js"

import "./EditableText.vue?vue&type=style&index=0&id=0a0393ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0a0393ba"

export default script